import { render, staticRenderFns } from "./JournalFilePreviewArea.vue?vue&type=template&id=77a371de&scoped=true&"
import script from "./JournalFilePreviewArea.vue?vue&type=script&lang=ts&"
export * from "./JournalFilePreviewArea.vue?vue&type=script&lang=ts&"
import style0 from "./JournalFilePreviewArea.vue?vue&type=style&index=0&id=77a371de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a371de",
  null
  
)

export default component.exports